import { TLoginDispatch, TRootLoginState } from "./store";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const useLoginDispatch: () => TLoginDispatch = useDispatch;
export const useLoginSelector: TypedUseSelectorHook<TRootLoginState> = useSelector;
